<div class="element-1">
  <div class="section-31" id="section-31"></div>
  <div class="section-32">
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
      <div class="card-4">
        <div class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <p class="log1">FMS</p>
          </div>
          <p class="log2">Financial Management Service</p>
          <h3 class="log-3 d-flex justify-content-center align-items-center mt-2">
            Login
          </h3>
        </div>
        <div class="card-body mt-3">
          <form [formGroup]="LoginForm">
            <div class="row mt-1 mb-2">
              <div class="col-12">
                <input class="form-control login-input-2" type="text" autocomplete="off" formControlName="Email"
                  name="Email" placeholder="UserName" [(ngModel)]="signin.userName" />

              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 mI-group">
                <input class="form-control login-input-2" autocomplete="false" [type]="Password"
                  formControlName="WebPassword" placeholder="Password" name="WebPassword"
                  [(ngModel)]="signin.password" />
                <i class="bi bi-eye-fill" *ngIf="show_pass" (click)="showPassWord()"></i>
                <i class="bi bi-eye-slash-fill" *ngIf="!show_pass" (click)="showPassWord()"></i>

              </div>
            </div>
            <div class="row mt-3">
              <div class="col mt-2 fogot-footer-1">
                <span class="f-11 d-flex flex-column">
                  <button type="submit" class="btn btn_md" style="border-radius: 25px" [disabled]="LoginForm.invalid"
                    [disabled]="!LoginForm.valid" (click)="OnboardLoginFunction()">
                    Login
                  </button></span>
                <span class="f-21 d-flex flex-column">
                  <button class="btn btn_md" (click)="MoveToNextPage('forgetpassword')" style="border-radius: 25px">
                    Forgot Password?
                  </button></span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>